<!-- sidebar for user profile -->
<template lang="html">
  <v-card class="side-card" max-height="60%">
    <!-- avatar -->
    <v-row class="d-flex justify-center py-5">
      <v-avatar size="150">
            <slot name="post-avatar">
              <img src="" alt="avatar">
            </slot>
          </v-avatar>
    </v-row>

    <!-- name -->
    <v-row class="d-flex justify-center">
      <v-card-title><slot name="username"></slot></v-card-title>
    </v-row>

    <!-- bio -->
    <v-row class="pb-7">
      <v-col class="px-10">
        <v-card-text>
          <slot name="bio"></slot>
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {

}
</script>

<style lang="css" scoped>
.side-card {
  position: fixed;
  z-index: 1;
  display: block;
  width: 16%;
}
</style>
